// extracted by mini-css-extract-plugin
module.exports = {"deliveryShimmer":"ShipRocketShimmer_deliveryShimmer__0roy_","delivery_message":"ShipRocketShimmer_delivery_message__ftbAH","shimmer":"ShipRocketShimmer_shimmer__1wW9n"};